import { Component, OnInit } from '@angular/core';
declare let $: any;

// declare let AOS: any;
// import * as Aos from 'aos';

@Component({
  selector: 'app-headquarter',
  templateUrl: './headquarter.component.html',
  styleUrls: ['./headquarter.component.css']
})
export class HeadquarterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

    // Aos.init(); 

    //FOR TOOLTIP
    // $('[data-bs-toggle="tooltip"]').tooltip();

    document.title = 'FCI - Food Corporation Of India, Govt. of India';
    var meta = document.createElement('meta');
      meta.name ='title';
      meta.content ='FCI - Food Corporation of India, Govt. of India';
      document.getElementsByTagName('head')[0].appendChild(meta);
    var meta_ = document.createElement('meta');
    meta_.name ='description';
    meta_.content ='Food Corporation of India, Govt. of India';
    document.getElementsByTagName('head')[0].appendChild(meta_);
    var _meta = document.createElement('meta');
    _meta.name ='keywords';
    _meta.content ='FCI, Food Grains, Food Corporation of India, Food Storage, Procurement, Sales, Movement Of Food Grains';
    document.getElementsByTagName('head')[0].appendChild(_meta);
  }

}
